import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "@izicvs/ui";
import { t } from "@lingui/macro";

type Props = {
  children: React.ReactNode;
  title?: string;
  description?: string;
  onConfirm: () => void;
};

// Wraps a trigger (e.g. a trash button) with a confirmation dialog so
// destructive actions require an explicit "Delete".
export const ConfirmDelete = ({ children, title, description, onConfirm }: Props) => (
  <AlertDialog>
    <AlertDialogTrigger asChild>{children}</AlertDialogTrigger>
    <AlertDialogContent>
      <AlertDialogHeader>
        <AlertDialogTitle>{title ?? t`Delete this item?`}</AlertDialogTitle>
        <AlertDialogDescription>
          {description ?? t`This action cannot be undone.`}
        </AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel>{t`Cancel`}</AlertDialogCancel>
        <AlertDialogAction className="bg-error text-white hover:bg-error/90" onClick={onConfirm}>
          {t`Delete`}
        </AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);
